/** управление пользователями
 */
import _ from "lodash";
import React from "react";
import { Route, Redirect, Switch, useRouteMatch } from "react-router-dom";
import { Error400 } from "views/pages/index";
import PageTitle, { BreadCrumbs } from "components/standart/PageTitle";
import IntlMessages from "util/intlMessages";
import { path } from "./init";
import AdvertisersTable from "./Table";
import AdvertiserInfo from "./Info";
import AddAdvertiser from "./Add";
import AdvertsSettings from "./Settings";

const Advertisers = (props) => {
  const { url, path } = useRouteMatch();
  const { breadCrumbs = new BreadCrumbs() } = props;

  breadCrumbs.push({
    title: <IntlMessages id="Advertisers" />,
    url,
    actions: [<AddAdvertiser />],
  });

  return (
    <div className="react-strap-doc">
      <Switch>
        <Route exact path={`${path}/advertisers`}>
          <PageTitle {...breadCrumbs} />

          <AdvertisersTable />
        </Route>

        <Route path={`${path}/advertisers/advertiser_:advertiserId`}>
          <AdvertiserInfo {...{ breadCrumbs }} />
        </Route>

        <Route exact path={`${path}/settings`}>
          <AdvertsSettings {...{ breadCrumbs }} />
        </Route>

        <Route exact path={path} render={() => <Redirect to={`${path}/advertisers`} />} />

        <Route component={Error400} />
      </Switch>
    </div>
  );
};

export default { path, component: Advertisers };
